import isMobile from 'is-mobile';
import { pathOr, assocPath } from 'lodash/fp';

const getLangProp = (prop, lang, obj) =>
  obj.hasOwnProperty(`${prop}_${lang}`) && obj[`${prop}_${lang}`]
    ? obj[`${prop}_${lang}`]
    : obj[prop];

const translateVideo = state => (video, index) => ({
  //...video,
  id: index,
  alternatives: video.alternatives.map(translateVideo(state)),
  alternativeTitle: getLangProp('alternative_title', state.language, video),
  tags: getLangProp('tags', state.language, video),
  databaseId: video.id,
  areas: video.areas,
  dimensions: video.dimensions,
  resources: video.resources,
  counter: video.counter,
  counterUnit: video.counterUnit,
  isWarmup: video.isWarmup,
  duration: pathOr(null, 'vimeo_video.duration', video),
  title: getLangProp('title', state.language, video),
  description: getLangProp('description', state.language, video),
  tipps: getLangProp('tipps', state.language, video),
  variants: getLangProp('variants', state.language, video),
  image: video.vimeo_video.image,
  vimeoFiles: video.vimeo_video.files,
});

export default {
  isMenuDrawerOpen: state => state.isMenuDrawerOpen,
  testimonials: state =>
    state.testimonials.map((testimonial, index) => ({
      ...testimonial,
      id: index,
      title: getLangProp('title', state.language, testimonial),
      tagline: getLangProp('tagline', state.language, testimonial),
      description: getLangProp('description', state.language, testimonial),
    })),
  videos: state => state.api.physio_videos.map(translateVideo(state)),
  playlists: state =>
    state.api.playlists
      .map(playlist => ({
        ...playlist,
        areas: playlist.area,
        isFavourite:
          state.api.user && state.api.user.favorites.includes(playlist.id),
      }))
      .map(playlist => ({
        ...playlist,
        title: getLangProp('title', state.language, playlist),
        tagline: getLangProp('tagline', state.language, playlist),
        description: getLangProp('description', state.language, playlist),
        videos: (playlist.videos || [])
          .map(translateVideo(state))
          .filter(video => video.vimeoFiles),
      })),
  liveStreams: state =>
    state.api.liveStreams.map(liveStream => ({
      title: getLangProp('title', state.language, liveStream),
      description: getLangProp('description', state.language, liveStream),
      url: liveStream.url,
      timestamp: liveStream.timestamp,
      past: liveStream.past,
      image: liveStream.title_image,
      imageWidth: parseInt(liveStream.title_image_width, 10),
      imageHeight: parseInt(liveStream.title_image_height, 10),
    })),
  isLoggedIn: state => Boolean(state.api.user),
  saveState: state => state.saveState,
  requestState: state => state.requestState,
  user: pathOr(null, 'api.user'),
  isPhysio: (state, getters) => Boolean(getters.user && getters.user.isPhysio),
  isMobile: () => isMobile(),
  isFilterOpen: state => state.isFilterOpen,
  hasFilter: state =>
    Boolean(
      state.filter.favorites ||
        state.filter.basfi ||
        state.filter.intensity ||
        state.filter.duration ||
        state.filter.area.length ||
        state.filter.resources.length ||
        state.filter.dimensions.length
    ),
  trainings: state =>
    state.api.trainings.map(training => ({
      ...training,
      playlist: training.playlist
        ? {
            id: training.playlist.id,
            duration: training.playlist.duration,
            title: getLangProp('title', state.language, training.playlist),
          }
        : null,
      programm: pathOr(null, 'programm', training),
      duration: training.duration,
    })),
  programms: state =>
    state.api.programms.map(programm => ({
      ...programm,
      videos: (programm.videos || [])
        .map(translateVideo(state))
        .filter(video => video.vimeoFiles),
    })),
  filteredPlaylists: (state, getters) => {
    if (
      (state.filter.portal || (getters.user && getters.user.portal)) == 'GLAD'
    ) {
      const playlists = getters.playlists.filter(q => q.portal == 'GLAD');

      return { type: 'every', playlists: playlists };
    }

    const filteredPlaylists = getters.playlists
      .filter(q => q.portal == 'RHEUMAFIT')
      .filter(
        p =>
          state.filter.duration === null ||
          ((!state.filter.duration.upper ||
            p.duration <= state.filter.duration.upper * 60) &&
            p.duration >= state.filter.duration.lower * 60)
      )

      .filter(
        p =>
          state.filter.intensity === null ||
          p.intensity == state.filter.intensity
      )

      .filter(
        p =>
          !state.filter.resources.length ||
          p.resources.every(r => state.filter.resources.includes(r))
      )
      .filter(
        p =>
          !state.filter.dimensions.length ||
          state.filter.dimensions.every(r => p.dimensions.includes(r))
      )
      .filter(p => !state.filter.favorites || p.isFavourite)
      .filter(
        q =>
          !state.filter.basfi ||
          !getters.user ||
          !getters.user.basfi ||
          getters.user.basfi.index <= q.basfiMax
      );

    const everyBodyPart = filteredPlaylists.filter(
      p =>
        !state.filter.area.length ||
        state.filter.area.every(a => p.area.includes(a))
    );

    const someBodyPart = filteredPlaylists.filter(
      p =>
        !state.filter.area.length ||
        state.filter.area.some(a => p.area.includes(a))
    );

    return everyBodyPart.length
      ? { type: 'every', playlists: everyBodyPart }
      : {
          type: someBodyPart.length ? 'some' : 'none',
          playlists: someBodyPart,
        };
  },
};



// WEBPACK FOOTER //
// ./src/store/getters.js